
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Titlebar from "@/components/ElementPropertiesPanel/Titlebar.vue";
import BlankSidebarContent from "@/components/ElementPropertiesPanel/BlankSidebarContent.vue";
import TabsAndControls from "@/components/ElementPropertiesPanel/TabsAndControls.vue";
import { uiStore } from "@/store/store";
import OxygenTabsAndControls from "@/oxygen/properties-panel/OxygenTabsAndControls.vue";
import { closeUiPanel } from "@/lib/panels/panels";

@Component({
  components: {
    Titlebar,
    TabsAndControls,
    BlankSidebarContent,
    OxygenTabsAndControls
  }
})
export default class OxygenElementPropertiesPanel extends Vue {
  get elementIsActive() {
    return !!uiStore.activeElement;
  }

  mounted() {
    if (!this.elementIsActive) {
      closeUiPanel("elementproperties");
    }
  }
}
